import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
    paper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'calc(100% - 60px)',
        maxWidth: '660px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        '@media (max-width: 767px)': {
            width: 'calc(100% - 32px)',
        },
        borderRadius: 0,
    },
    backdrop: {
        zIndex: '1',
        position: 'absolute',
        top: '0',
        width: 'calc(100% - 30px)',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.4)',
        borderRadius: '4px;',
    },
});
const ModalContainer = ({ children, onClickAway = () => {}, className = '' }) => {
    const { backdrop, paper } = useStyles();
    return (
        <div className={backdrop}>
            <div style={{ display: 'relative' }}>
                <ClickAwayListener onClickAway={onClickAway}>
                    <div className="row no-gutter">
                        <Paper
                            className={`${paper} ${className}`}
                        >
                            {children}
                        </Paper>
                    </div>
                </ClickAwayListener>
            </div>
        </div>
    );
};

export default ModalContainer;
